import React from "react";
import { useEffect, useState } from "react";
import { useParams } from 'react-router';
import { useTranslation } from "react-i18next";
import i18next from 'i18next';
import { BasicTable } from '@synergy/table';
import { Flex } from 'antd';
import { Text } from '../../../../Atomics/Text';



export const EventsTable = ({ dataToFilter, eventsTableRef, hasEvents, isEventsLoading }) => {
  const { t } = useTranslation();
  const { id } = useParams();

  /*const [dataEvents, setDataEvents] = useState(null);
  const {
    data: eventsData,
    isLoading: eventsIsLoading,
    refetch: refetchEventsData
  } = useFetch(query.path.detailRegistryEvents, 'getDetailRegistryEvents',
    { id: id, filters: JSON.stringify(dataToFilter) });

   useEffect(() => {
    isEventsLoading(eventsIsLoading)
  }, [eventsIsLoading]);

  useEffect(() => {
    if (eventsData?.data) {
      let array = [];
      eventsData?.data.map((el, idx) => {
        array.push(
          {
            key: idx,
            creationDate: el['Creation Date'],
            eventDescription: el['Event Description'],
            startDate: el['Start Date'],
            endDate: el['End Date'],
            eventSeverity: el['Event Severity']
          }
        )
      })
      setDataEvents(array)
       hasEvents(array) 
    }
  }, [eventsData?.data]);

  useEffect(() => {
    hasEvents(null)
    refetchEventsData();
  }, [dataToFilter]); */

  let dataEvents = [
    {
        "id": "cac6f869-4fec-e1eb-a4e8-79c0a0e0b3b9",
        "label": "Event",
        "Event Description": "Missing Data",
        "Alarm Generated": "False",
        "latitude": "",
        "Parent Item": "W3siUGFyZW50IEl0ZW0gSUQiOiAiNDJjNmIzMjMtYTI4My00OWMwLTZjNzUtNzQzOThjOTZlNTk2IiwgIlBhcmVudCBJdGVtIE5hbWUiOiAiRUIgRkFMQ1x1MDBjM08gKyBKSSBGQUxDXHUwMGMzTyAtIDEiLCAiUGFyZW50IEl0ZW0gVHlwb2xvZ3kiOiAiU2Nob29sIiwgIlBhcmVudCBJdGVtIEFkZHJlc3MiOiAiUnVhIERvIEZhbGNcdTAwZTNvIDcwOCA0MzAwLTE3OCJ9XQ==",
        "Update Date": "",
        "active": "1",
        "crud_status": "created",
        "Federated Item": "14c6d25a-e49a-f8ad-aa12-5ac8798ffff4",
        "Event Severity": "INFO",
        "Creation Date": "2024-02-28 17:45:36",
        "Start Date": "2024-02-27 18:15:00",
        "End Date": "2024-02-28 00:00:00",
        "Installation Point": "TA2310409312",
        "tenant": "TOP/ADEPORTO/PORTO/CM PORTO",
        "longitude": "",
        "status": "Created"
    },
    {
        "id": "4ac6f869-4d75-4535-5a3f-a450b7730452",
        "label": "Event",
        "Event Description": "Missing Data",
        "Alarm Generated": "False",
        "latitude": "",
        "Parent Item": "W3siUGFyZW50IEl0ZW0gSUQiOiAiNDJjNmIzMjMtYTI4My00OWMwLTZjNzUtNzQzOThjOTZlNTk2IiwgIlBhcmVudCBJdGVtIE5hbWUiOiAiRUIgRkFMQ1x1MDBjM08gKyBKSSBGQUxDXHUwMGMzTyAtIDEiLCAiUGFyZW50IEl0ZW0gVHlwb2xvZ3kiOiAiU2Nob29sIiwgIlBhcmVudCBJdGVtIEFkZHJlc3MiOiAiUnVhIERvIEZhbGNcdTAwZTNvIDcwOCA0MzAwLTE3OCJ9XQ==",
        "Update Date": "",
        "active": "1",
        "crud_status": "created",
        "Federated Item": "14c6d25a-e49a-f8ad-aa12-5ac8798ffff4",
        "Event Severity": "INFO",
        "Creation Date": "2024-02-28 17:45:21",
        "Start Date": "2024-02-27 18:15:00",
        "End Date": "2024-02-28 00:00:00",
        "Installation Point": "TA2310409312",
        "tenant": "TOP/ADEPORTO/PORTO/CM PORTO",
        "longitude": "",
        "status": "Created"
    },
    {
        "id": "28c6f869-4856-970b-cbe1-3636e9be5883",
        "label": "Event",
        "Event Description": "Missing Data",
        "Alarm Generated": "False",
        "latitude": "",
        "Parent Item": "W3siUGFyZW50IEl0ZW0gSUQiOiAiNDJjNmIzMjMtYTI4My00OWMwLTZjNzUtNzQzOThjOTZlNTk2IiwgIlBhcmVudCBJdGVtIE5hbWUiOiAiRUIgRkFMQ1x1MDBjM08gKyBKSSBGQUxDXHUwMGMzTyAtIDEiLCAiUGFyZW50IEl0ZW0gVHlwb2xvZ3kiOiAiU2Nob29sIiwgIlBhcmVudCBJdGVtIEFkZHJlc3MiOiAiUnVhIERvIEZhbGNcdTAwZTNvIDcwOCA0MzAwLTE3OCJ9XQ==",
        "Update Date": "",
        "active": "1",
        "crud_status": "created",
        "Federated Item": "14c6d25a-e49a-f8ad-aa12-5ac8798ffff4",
        "Event Severity": "INFO",
        "Creation Date": "2024-02-28 17:45:36",
        "Start Date": "2024-02-27 18:15:00",
        "End Date": "2024-02-28 00:00:00",
        "Installation Point": "TA2310409312",
        "tenant": "TOP/ADEPORTO/PORTO/CM PORTO",
        "longitude": "",
        "status": "Created"
    },
    {
        "id": "82c6f869-4b18-dcbf-01bb-1a07e0a83fb1",
        "label": "Event",
        "Event Description": "Missing Data",
        "Alarm Generated": "False",
        "latitude": "",
        "Parent Item": "W3siUGFyZW50IEl0ZW0gSUQiOiAiNDJjNmIzMjMtYTI4My00OWMwLTZjNzUtNzQzOThjOTZlNTk2IiwgIlBhcmVudCBJdGVtIE5hbWUiOiAiRUIgRkFMQ1x1MDBjM08gKyBKSSBGQUxDXHUwMGMzTyAtIDEiLCAiUGFyZW50IEl0ZW0gVHlwb2xvZ3kiOiAiU2Nob29sIiwgIlBhcmVudCBJdGVtIEFkZHJlc3MiOiAiUnVhIERvIEZhbGNcdTAwZTNvIDcwOCA0MzAwLTE3OCJ9XQ==",
        "Update Date": "",
        "active": "1",
        "crud_status": "created",
        "Federated Item": "14c6d25a-e49a-f8ad-aa12-5ac8798ffff4",
        "Event Severity": "INFO",
        "Creation Date": "2024-02-28 17:45:21",
        "Start Date": "2024-02-27 18:15:00",
        "End Date": "2024-02-28 00:00:00",
        "Installation Point": "TA2310409312",
        "tenant": "TOP/ADEPORTO/PORTO/CM PORTO",
        "longitude": "",
        "status": "Created"
    }
]

  return (
    <Flex id='Events' className='ant-anchors-content-item' gap={32} vertical="true">
      <Text $fontColor='coolgray-12' $fontSize='text_xl' $weight='regular' $marginRight='s03'>{t('events')}</Text>
      <div ref={eventsTableRef}>
        <BasicTable tableId='eventsTable' fetchData={dataEvents} language={i18next.resolvedLanguage} />
      </div>
    </Flex>
  )
}